import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";
//@ts-ignore
import logo from "../../assets/logo-white.png";
import BonusCard from "../../components/BonusCard";
import { BonusesAPI } from "../../api/bonuses";
import PreLoader from "../../components/PreLoader";
import { useTranslation } from "react-i18next";

const Bonuses = () => {
  const { t } = useTranslation();
  const [bonuses, setBonuses] = useState<any[]>();
  async function fetchBonuses() {
    try {
      const res = await BonusesAPI.getActive();
      if (res.data) {
        const bonuses = res.data;
        const sortedBonuses = Array.isArray(bonuses)
          ? bonuses.sort(
              (a, b) => parseInt(a.homeSequence) - parseInt(b.homeSequence)
            )
          : [];
        setBonuses(sortedBonuses);
      }
    } catch (error) {
      console.log("Something went wrong. Try Again!");
    }
  }
  useEffect(() => {
    fetchBonuses();
  }, []);
  // const sortedOffers = [...OffersData].sort((a, b) =>
  //   a.dealOfTheWeek === b.dealOfTheWeek ? 0 : a.dealOfTheWeek ? -1 : 1
  // );
  // const offersToDisplay = showAllOffers
  //   ? sortedOffers
  //   : sortedOffers.slice(0, 10);
  // const toggleShowMore = () => setShowAllOffers(!showAllOffers);

  if (!bonuses) return <PreLoader />;

  return (
    <Container
      fluid
      className="m-0 flex flex-col min-h-full w-full items-center text-white"
    >
      {/* Navbar */}
      <section className="w-full lg:w-[75%] lg:mt-[2rem] mb-2">
        <Link to="/">
          <img
            src={logo}
            alt="Casino24"
            className="object-cover w-[10rem] lg:w-[15rem] my-3 cursor-pointer"
          />
        </Link>
      </section>

      {/* Best Deals */}
      {bonuses && (
        <section className="w-full lg:w-[75%] flex flex-col justify-center items-center">
          <h2 className="my-[5rem] text-[1.6rem] lg:text-[2.5rem] font-defaultFont text-center">
            {t("best_bonuses")}
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
            {bonuses.map((bonus, index) => (
              <BonusCard
                index={index}
                logo={bonus.picture}
                contentName={bonus.contentName}
                category={bonus.category.value}
                refURL={bonus.refURL}
                bonusCode={bonus.bonusCode}
                description={bonus.description}
              />
            ))}
          </div>

          {/* <div className="w-[90%] lg:w-full">
          {offersToDisplay.map((offer, index) => (
            <OffersCard key={index} index={index} offer={offer} />
          ))}
          <div
            onClick={toggleShowMore}
            className={`text-center text-white py-4 cursor-pointer select-none ${
              sortedOffers.length % 2 === 0  "bg-[#3a3a3a]" : "bg-[#2a2a2a]"
            }`}
          >
            {showAllOffers ? "Weniger anzeigen" : "Mehr Anbieter anzeigen"}
          </div>
        </div> */}
        </section>
      )}
    </Container>
  );
};

export default Bonuses;
